export default {"src":"/_next/static/media/mx-sol-icon2.639a6007.svg","height":38,"width":38};